import { ClassName } from '@boxcryptor-web/shared/class-name';
import React from 'react';
import { useExternalLinkContext } from './ExternalLinkContext';

export type Target = '_self' | '_blank';
export type ExternalLink = {
  href: string;
  target?: Target;
  state?: { [x: string]: unknown };
  rel?: string;
  title?: string;
  tabIndex?: number;
  trackingId?: string;
};
export type ExternalLinkProps = ClassName<ExternalLink & { children: React.ReactNode }>;
export const ExternalLink: React.FC<ExternalLinkProps> = (props) => {
  const context = useExternalLinkContext();
  const replacedLink = context.getReplacedExternalLink(props);
  return (
    <context.externalLinkComponent {...replacedLink} className={props.className}>
      {props.children}
    </context.externalLinkComponent>
  );
};
